import { jsx as _jsx } from "react/jsx-runtime";
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { forwardRef, useCallback } from 'react';
const DEV_SITE_KEY = '10000000-ffff-ffff-ffff-000000000001';
const PROD_SITE_KEY = 'fc346952-3372-4a24-a1f6-85f4f856ea38';
const resolveSiteKey = () => {
    const env = import.meta.env;
    if (env.VITE_HCAPTCHA_SITE_KEY)
        return env.VITE_HCAPTCHA_SITE_KEY;
    return env.MODE === 'development' ? DEV_SITE_KEY : PROD_SITE_KEY;
};
const HCaptchaComponent = forwardRef(({ onVerify, onError, onExpire, theme = 'light', size = 'normal', disabled = false, className }, ref) => {
    const siteKey = resolveSiteKey();
    const handleVerify = useCallback((token) => {
        onVerify(token);
    }, [onVerify]);
    const handleError = useCallback((error) => {
        console.error('hCaptcha error:', error);
        onError?.(error);
    }, [onError]);
    const handleExpire = useCallback(() => {
        console.log('hCaptcha expired');
        onExpire?.();
    }, [onExpire]);
    if (disabled) {
        return null;
    }
    return (_jsx("div", { className: className, children: _jsx(HCaptcha, { ref: ref, sitekey: siteKey, onVerify: handleVerify, onError: handleError, onExpire: handleExpire, theme: theme, size: size }) }));
});
HCaptchaComponent.displayName = 'HCaptchaComponent';
export { HCaptchaComponent };
